import { trackEvent, trackGotEmail, trackSurveyAnswers } from "./api/tracker";
import {
  addSurveyAnswers,
  SurveyAnswersState,
} from "./redux/slices/surveyAnswers";
import { saveMainSurveyAnswers } from "./redux/slices/userData";
import { AppDispatch } from "./redux/store";
import { captureException } from "./sentry";
import { typedKeys } from "./typeWrappers";

export function prepareAndTrackSurveyAnswers(
  currentQuestionId: string,
  surveyAnswers: SurveyAnswersState
) {
  const currentAnswers: SurveyAnswersState = {};

  switch (currentQuestionId) {
    case "basic":
    case "basicUK":
    case "basicMet":
    case "basicMetUK":
      typedKeys(surveyAnswers).forEach((key) => {
        if (
          key.includes("height") ||
          key.includes("weight") ||
          key.includes("currentBMI")
        ) {
          currentAnswers[key] = surveyAnswers[key];
        }
      });
      break;
    case "idealWeight":
      currentAnswers.idealWeight = surveyAnswers.idealWeight;
      currentAnswers.idealWeightKg = surveyAnswers.idealWeightKg;
      currentAnswers.targetBMI = surveyAnswers.targetBMI;
      break;
    case "idealWeightKg":
      currentAnswers.idealWeightKg = surveyAnswers.idealWeightKg;
      currentAnswers.targetBMI = surveyAnswers.targetBMI;
      break;
    case "idealWeightImp":
      currentAnswers.idealWeightKg = surveyAnswers.idealWeightKg;
      currentAnswers.idealWeightUnit = surveyAnswers.idealWeightUnit;
      currentAnswers.targetBMI = surveyAnswers.targetBMI;
      break;
    case "gender":
      currentAnswers.gender = [surveyAnswers.gender[0]];
      if (surveyAnswers.gender[0] === "selfIdentify") {
        [, currentAnswers.selfIdentify] = surveyAnswers.gender;
      }
      break;
    case "importantDateDetails":
      currentAnswers.importantDateDetails = surveyAnswers.importantDateDetails;
      if (surveyAnswers.importantDate) {
        currentAnswers.importantDate = surveyAnswers.importantDate;
      }
      if (surveyAnswers.importantDateSubDetails) {
        currentAnswers.importantDateSubDetails =
          surveyAnswers.importantDateSubDetails;
      }
      break;
    default:
      currentAnswers[currentQuestionId] = surveyAnswers[currentQuestionId];
  }

  trackSurveyAnswers(currentQuestionId, currentAnswers);
}

export async function completeMainSurvey({
  surveyAnswers,
  params: {
    finishedEvent = "FinishedMainSurvey",
    lead = "trackLead",
    dateKey,
    extraProps,
  } = {},
  dispatch,
}: {
  surveyAnswers: SurveyAnswersState;
  params?: {
    finishedEvent?: string;
    lead?: string;

    dateKey?: string;
    extraProps?: JsonObject;
  };
  dispatch: AppDispatch;
}): Promise<void> {
  try {
    // Update the Redux store.
    dispatch(addSurveyAnswers(surveyAnswers));

    const name = surveyAnswers.name || "";
    const email = surveyAnswers.email || "";

    await dispatch(
      saveMainSurveyAnswers(surveyAnswers, {
        dateKey,
        extraProps,
      })
    );

    if (email) {
      window.conversionTracker[lead](email, name, surveyAnswers);
      await trackGotEmail(email);
    }

    await trackEvent(finishedEvent, surveyAnswers);
  } catch (e) {
    // TODO: Tag and throw or log and throw?
    captureException(e, "onCompleteMainSurvey");
    throw e;
  }
}
